import { lazy } from "react";
import getTenantId from "./components/Tenent";

const tenantId = getTenantId();

const NewUploadUI = lazy(
  () => import("./pages/custumdatastream/fileprocessing/ManageUploads"),
);
const OldUploadUI = lazy(() => import("./pages/custumdatastream"));

const NewEmissionsUI = lazy(() => import("./pages/activities/viewdata"));

const OldEmissionsUI = lazy(() => import("./pages/activities/ActivityList"));

const newUITenant = [
  "stage",
  "bvk",
  "johncotton",
  "dreams",
  "showcase",
  "sobha",
  "bajajsons",
  "nuevosol",
  "viyash",
  "demo",
  "mastek",
].includes(tenantId);

export const publicRoutes = [
  {
    path: "/sso/callback",
    exact: true,
    element: lazy(() => import("./pages/auth/SsoTokenHelper.jsx")),
  },
  {
    path: "/maker-checker/direct-entry",
    exact: true,
    element: lazy(() => import("./pages/maker-checker/DirectDataEntry.jsx")),
  },
  {
    path: "/v1/emission-activities",
    exact: true,
    element: newUITenant ? OldEmissionsUI : null,
  },

  {
    path: "/supplier/upload/form",
    exact: true,
    element: lazy(
      () => import("./pages/esgmodule/Supplierupload/Supplierform"),
    ),
  },

  {
    path: "/esg/journey",
    exact: true,
    element: lazy(() => import("./pages/esgmodule/Journey/Journey")),
  },
  //new esg ui

  {
    path: "/esg/poc/:id", // Add :id as a dynamic parameter
    exact: true,
    element: lazy(() => import("./pages/esgmodule/Metricnodelist")),
  },

  //  {
  //   path: "/esg/poc/submitter", // Add :id as a dynamic parameter
  //   exact: true,
  //   element: lazy(() => import("./pages/esgmodule/Metricnodelist")),
  // },

  {
    path: "/external/submitted/supplier-engagement-data",
    exact: true,
    element: lazy(() => import("./pages/forms/SupplierEngagementSubmitter")),
  },
  {
    path: "/cbam/submitter/:cbamToken/form",
    exact: true,
    element: lazy(() => import("./pages/forms/CbamSubmitter")),
  },
  {
    path: "/cbam/submitter/:cbamToken/form",
    exact: true,
    element: lazy(() => import("./pages/forms/CbamSubmitter")),
  },
  {
    path: "/v1/custumdatastream/:type",
    exact: true,
    element: newUITenant ? OldUploadUI : null,
  },
  {
    path: "/login",
    exact: true,
    element: lazy(() => import("./pages/auth/Login")),
  },

  {
    path: "/forgot-password",
    exact: true,
    element: lazy(() => import("./pages/auth/ForgotPassword")),
  },

  {
    path: "/supplier",
    exact: true,
    element: lazy(() => import("./pages/supplierassesment/index")),
  },
  {
    path: "/supplier/data",
    exact: true,
    element: lazy(() => import("./pages/supplierassesment/Supplierdata")),
  },

  {
    path: "/supplier/form",
    exact: true,
    element: lazy(() => import("./pages/supplierassesment/form")),
  },

  {
    path: "/reset-pw/:token",
    exact: true,
    element: lazy(() => import("./pages/auth/ResetPassword")),
  },

  {
    path: "/403",
    exact: true,
    element: lazy(() => import("./pages/auth/Forbidden")),
  },

  {
    path: "/not-found",
    exact: true,
    element: lazy(() => import("./pages/auth/NotFound")),
  },
  {
    path: "/sso/callback",
    exact: true,
    element: lazy(() => import("./pages/auth/NotFound.jsx")),
  },

  {
    path: "/cbam/submit",
    exact: true,
    element: lazy(() => import("./pages/cbam/CbamSubmit")),
  },

  //////////////////////

  // {
  //   path: "/esg/create-project",
  //   exact: true,
  //   element: lazy(() => import("./pages/esgmodule/Addproject")),
  // },
  // {
  //   path: "/esg/new/dashboard",
  //   exact: true,
  //   element: lazy(() => import("./pages/esgmodule/dashboard/ESGDashboard")),
  // },
  // {
  //   path: "/personalise",
  //   exact: true,
  //   // element: lazy(() => import("./pages/esgmodule/Home")),
  //   element: lazy(() => import("./pages/esgmodule/Personalise")),
  // },
  // {
  //   path: "/home",
  //   exact: true,
  //   element: lazy(() => import("./pages/esgmodule/ESGJourney")),
  // },
  // {
  //   path: "/esg/targets",
  //   exact: true,
  //   element: lazy(() => import("./pages/esgmodule/ESGTargets")),
  // },
  // {
  //   path: "/esg/framework",
  //   exact: true,
  //   element: lazy(() => import("./pages/esgmodule/ESGPillars")),
  // },
  // {
  //   path: "/esg/reports",
  //   exact: true,
  //   element: lazy(() => import("./pages/esgmodule/reports/GRI/GetStarted")),
  // },
  // {
  //   path: "/esg/reports/disclosures",
  //   exact: true,
  //   element: lazy(() => import("./pages/esgmodule/reports/GRI/Disclosures")),
  // },
  // {
  //   path: "/esg/reports/summary",
  //   exact: true,
  //   element: lazy(() => import("./pages/esgmodule/reports/GRI/Summary")),
  // },

  
   {
    path: "/dashboard/initiatives",
    exact: true,
    element: lazy(() => import("./pages/dashboard/Initiatives/Initiatives.jsx"))
  },
 
];

export const protectedRoutes = [
  // {
  //   path: "*",
  //   element: lazy(() => import("./pages/PageNotFound")),
  // },
  //////////////////////////////////////////////////////////////////////

  {
    path: "/cbam",
    exact: true,
    element: lazy(() => import("./pages/cbam/CbamDashboard")),
  },
  {
    path: "/cbam/create-disclosure",
    exact: true,
    element: lazy(() => import("./pages/cbam/CreateDisclosure")),
  },
  {
    path: "/cbam/fuel-energy-logs",
    exact: true,
    element: lazy(() => import("./pages/cbam/FuelEnergyTable")),
  },
  {
    path: "/cbam/supplier-outreach",
    exact: true,
    element: lazy(() => import("./pages/cbam/SupplierOutreach")),
  },
  {
    path: "/cbam/liability",
    exact: true,
    element: lazy(() => import("./pages/cbam/CbamLiability")),
  },
  {
    path: "/cbam/upload-logs",
    exact: true,
    element: lazy(() => import("./pages/cbam/CbamUploadLogs")),
  },
  {
    path: "/cbam/disclosure/product/:id",
    exact: true,
    element: lazy(() => import("./pages/cbam/CbamProductDetail")),
  },
  {
    path: "/esg/create-project",
    exact: true,
    element: lazy(() => import("./pages/esgmodule/Addproject")),
  },

  {
    path: "/esg/config/dashboard",
    exact: true,
    element: lazy(
      () => import("./pages/esgrewampmodule/Configdashboard/Config"),
    ),
  },

  {
    path: "/esg/poc/submitter",
    exact: true,
    element: lazy(() => import("./pages/esgmodule/Submitter")),
  },

  {
    path: "/esg/poc/approver", // Add :id as a dynamic parameter
    exact: true,
    element: lazy(() => import("./pages/esgrewampmodule/Approver/Approve")),
  },

  {
    path: "/esg/formtracking", // Add :id as a dynamic parameter
    exact: true,
    element: lazy(() => import("./pages/esgmodule/Formtracking")),
  },
  {
    path: "/esg/new/dashboard",
    exact: true,
    element: lazy(() => import("./pages/esgmodule/dashboard/ESGDashboard")),
  },

  {
    path: "/esg/raiserequest", // Add :id as a dynamic parameter
    exact: true,
    element: lazy(() => import("./pages/esgmodule/Mulrirequest")),
  },

  {
    path: "/esg/projects/:metricId",
    exact: true,
    element: lazy(() => import("./pages/esgmodule/project/metrixid")),
  },
  {
    path: "/esg/metricdata",
    exact: true,
    element: lazy(() => import("./pages/esgmodule/project/ManageProject")),
  },

  {
    path: "/supplier/upload",
    exact: true,
    element: lazy(() => import("./pages/esgmodule/Supplierupload/Supplier")),
  },

  {
    path: "/esg/journey/onboarding",
    exact: true,
    element: lazy(
      () => import("./pages/esgrewampmodule/onboarding/Onboaringhome"),
    ),
  },

  {
    path: "/esg/new/poc",
    exact: true,
    element: lazy(() => import("./pages/esgrewampmodule/poc/Pocnode")),
  },
  // {
  //   path: "/esg/new/poc",
  //   exact: true,
  //   element: lazy(() => import("./pages/esgrewampmodule/poc/Poc")),
  // },

  {
    path: "/esg/journey/questorie",
    exact: true,
    element: lazy(() => import("./pages/esgrewampmodule/onboarding/Quatiorie")),
  },

  {
    path: "/esg/journey/onboarding/upload",
    exact: true,
    element: lazy(
      () => import("./pages/esgrewampmodule/onboarding/Uploadonbording"),
    ),
  },

  {
    path: "/esg/journey/onboarding/upload/suggestion",
    exact: true,
    element: lazy(
      () => import("./pages/esgrewampmodule/onboarding/Uploadsuggestion"),
    ),
  },

  {
    path: "/esg/data",
    exact: true,
    element: lazy(() => import("./pages/esgrewampmodule/Datalanding/Data")),
  },

  {
    path: "/esg/metricmanagment",
    exact: true,
    element: lazy(
      () => import("./pages/esgrewampmodule/metricmanagment/Metricmanagment"),
    ),
  },

  {
    path: "/esg/home",
    exact: true,
    element: lazy(() => import("./pages/esgrewampmodule/Home/Home")),
  },

  {
    path: "/personalise",
    exact: true,
    element: lazy(() => import("./pages/esgmodule/Personalise")),
  },
  {
    path: "/home",
    exact: true,
    element: lazy(() => import("./pages/esgmodule/ESGJourney")),
  },
  {
    path: "/esg/targets",
    exact: true,
    element: lazy(() => import("./pages/esgmodule/ESGTargets")),
  },
  {
    path: "/esg/framework",
    exact: true,
    element: lazy(() => import("./pages/esgmodule/ESGPillars")),
  },
  {
    path: "/esg/poc",
    exact: true,
    element: lazy(() => import("./pages/esgmodule/Poc")),
  },

  {
    path: "/esg/reports",
    exact: true,
    element: lazy(() => import("./pages/esgmodule/reports/GRI/GetStarted")),
  },
  {
    path: "/esg/reports/disclosures",
    exact: true,
    element: lazy(() => import("./pages/esgmodule/reports/GRI/Disclosures")),
  },
  {
    path: "/esg/reports/summary",
    exact: true,
    element: lazy(() => import("./pages/esgmodule/reports/GRI/Summary")),
  },
  ////////////////////////////////////////////////////////////////////////
  {
    path: "/supplier-engagement",
    exact: true,
    element: lazy(() => import("./pages/supplier-engagement/Suppliers")),
  },
  {
    path: "/supplier-engagement/:supplierName",
    exact: true,
    element: lazy(() => import("./pages/supplier-engagement")),
  },
  {
    path: "/supplier-engagement/:supplierName",
    exact: true,
    element: lazy(() => import("./pages/supplier-engagement")),
  },
  // {
  //   path: "/reports/GHG",
  //   exact: true,
  //   element: lazy(
  //     () =>
  //       import("./pages/reports/GHGInventory/ProtocalReport/CreateProtocalReport"),
  //   ),
  // },
  // {
  //   path: "/reports/GHG/begin/:node_id",
  //   exact: true,
  //   element: lazy(() => import("./pages/reports/ghg-protocol-report/Layout.jsx"))
  // },
  // {
  //   path: "/reports/GHG/edit/:node_ids",
  //   exact: true,
  //   element: lazy(() => lazy(() => import("./pages/reports/ghg-protocol-report/ReportLayout.jsx")))
  // },
  {
    path: "/reports/GHG/protocol_report/:nodeId/:start/:end",
    exact: true,
    element: lazy(
      () => import("./pages/reports/GHGInventory/ProtocalReport/Page1"),
    ),
  },
  {
    path: "/information/account",
    exact: true,
    element: lazy(() => import("./pages/Account")),
  },
  {
    path: "/testing",
    exact: true,
    element: lazy(() => import("./pages/testing")),
  },
   {
    path: "/dashboard/initiatives/compare",
    exact: true,
    element: lazy(() => import("./pages/dashboard/Initiatives/Compare.jsx"))
  },

  // Categories
  {
    path: "/admin/categories",
    exact: true,
    element: lazy(() => import("./pages/category/CategoryList")),
  },
  {
    path: "/admin/category/edit/:id",
    exact: true,
    element: lazy(() => import("./pages/category/CategoryForm")),
  },
  {
    path: "/admin/category/create",
    exact: true,
    element: lazy(() => import("./pages/category/CategoryForm")),
  },

  // users
  // /information/update-password
  {
    path: "/information/admin",
    exact: true,
    element: lazy(() => import("./pages/admin-dashboard/CreateRole")),
  },
  {
    path: "/information/admin/dashboard/:role_id",
    exact: true,
    element: lazy(() => import("./pages/admin-dashboard/PermissionDashboard")),
  },
  // {
  //   path: "/information/admin/module-selection",
  //   exact: true,
  //   element: lazy(() => import("./pages/admin-dashboard/PermissionDashboard")),
  // },
  {
    path: "/information/users",
    exact: true,
    element: lazy(() => import("./pages/users/Users")),
  },
  {
    path: "/information/update-password",
    exact: true,
    element: lazy(() => import("./pages/Updatepassword")),
  },
  {
    path: "/information/users/create",
    exact: true,
    element: lazy(() => import("./pages/users/UsersForm")),
  },
  {
    path: "/information/users/edit/:id",
    exact: true,
    element: lazy(() => import("./pages/users/UsersForm")),
  },

  {
    path: "/information/constants",
    exact: true,
    element: lazy(() => import("./pages/Constants")),
  },
  {
    path: "/information/prompt-reports",
    exact: true,
    element: lazy(() => import("./pages/PromptAndReports")),
  },
  {
    path: "/information/admin/module-selection",
    exact: true,
    element: lazy(() => import("./pages/admin-dashboard/ModuleSelection")),
  },

  // suppliers

  {
    path: "/admin/supplier",
    exact: true,
    element: lazy(() => import("./pages/admin/suppliers/SupplierList")),
  },
  {
    path: "/admin/supplier/create",
    exact: true,
    element: lazy(() => import("./pages/admin/suppliers/SupplierForm")),
  },
  {
    path: "/admin/supplier/edit/:id",
    exact: true,
    element: lazy(() => import("./pages/admin/suppliers/SupplierForm")),
  },
  //buyers
  {
    path: "/admin/buyers",
    exact: true,
    element: lazy(() => import("./pages/admin/buyers/BuyerList")),
  },
  {
    path: "/admin/buyers/create",
    exact: true,
    element: lazy(() => import("./pages/admin/buyers/BuyerForm")),
  },
  {
    path: "/admin/buyers/edit/:id",
    exact: true,
    element: lazy(() => import("./pages/admin/buyers/BuyerForm")),
  },
  //products
  {
    path: "/admin/products",
    exact: true,
    element: lazy(() => import("./pages/admin/products/ProductList")),
  },
  {
    path: "/admin/products/create",
    exact: true,
    element: lazy(() => import("./pages/admin/products/ProductForm")),
  },
  {
    path: "/admin/products/edit/:id",
    exact: true,
    element: lazy(() => import("./pages/admin/products/ProductForm")),
  },

  //spend group

  {
    path: "/information/spend-group",
    exact: true,
    element: lazy(() => import("./pages/sector/Sector")),
  },
  {
    path: "/information/spend-group/create",
    exact: true,
    element: lazy(() => import("./pages/sector/SectorForm")),
  },
  {
    path: "/information/spend-group/edit/:id",
    exact: true,
    element: lazy(() => import("./pages/sector/SectorForm")),
  },

  //logs
  {
    path: "/information/activity-logs",
    exact: true,
    element: lazy(() => import("./pages/Logs")),
  },
  {
    path: "/information/activity-logs/:id",
    exact: true,
    element: lazy(() => import("./pages/Logs/LogDetails")),
  },

  // org hierarchy
  {
    path: "/information/organization-hierarchy",
    exact: true,
    element: lazy(() => import("./pages/org-hierarchy/Hierarchy")),
  },
  {
    path: "/information/organization-hierarchy/create",
    exact: true,
    element: lazy(() => import("./pages/org-hierarchy/Hierarchyform")),
  },
  {
    path: "/information/organization-hierarchy/edit/:id",
    exact: true,
    element: lazy(() => import("./pages/org-hierarchy/Hierarchyform")),
  },
  {
    path: "/information/organization-hierarchy/add/:add/:parent",
    exact: true,
    element: lazy(() => import("./pages/org-hierarchy/Hierarchyform")),
  },

  // Tasks

  {
    path: "/task-list",
    exact: true,
    element: lazy(() => import("./pages/task/TaskList")),
  },
  {
    path: "/task-list/:id",
    exact: true,
    element: lazy(() => import("./pages/task/TaskDetails")),
  },

  {
    path: "/targestcreate",
    exact: true,
    element: lazy(() => import("./pages/NewTargetEmmision/Target")),
  },

  {
    path: "/createtarget",
    exact: true,
    element: lazy(() => import("./pages/NewTargetEmmision/Createtarget")),
  },

  {
    path: "/settarget",
    exact: true,
    element: lazy(() => import("./pages/NewTargetEmmision/SetTarget")),
  },

  // activities
  {
    path: "/emission-activities",
    exact: true,
    element: lazy(() => import("./pages/activities/viewdata")),
  },
  {
    path: "/emission-activities/uploads",
    exact: true,
    element: newUITenant ? NewUploadUI : OldUploadUI,
  },
  {
    path: "/archived/files",
    exact: true,
    element: lazy(() => import("./pages/custumdatastream/ManageUploads")),
  },
  {
    path: "/upload-stream/:type",
    exact: true,
    element: lazy(() => import("./pages/uploadstream/Upload")),
  },
  {
    path: "/emission-activities/create",
    exact: true,
    element: lazy(
      () => import("./pages/activities/create-activity/CreateActivity"),
    ),
  },
  {
    path: "/emission-activities/optimize",
    exact: true,
    element: lazy(
      () => import("./pages/activities/optimize-matches/ManageMatches"),
    ),
  },
  {
    path: "/emission-activities/optimize/:id",
    exact: true,
    element: lazy(
      () => import("./pages/activities/optimize-matches/ManageMatches"),
    ),
  },
  {
    path: "/emission-activities/:inputGroupId",
    exact: true,
    element: lazy(() => import("./pages/activities/Activity")),
  },
  {
    path: "/emission-activities/:inputGroupId/category/:categoryId",
    exact: true,
    element: lazy(() => import("./pages/activities/Activity")),
  },

  {
    path: "/emission-activities/:inputGroupId/category/:categoryId/purchase-goods/:type",
    exact: true,
    element: lazy(() => import("./pages/purchase-goods/PurchaseGoods")),
  },
  {
    path: "/emission-activities/:inputGroupId/category/:categoryId/capital-goods/:type",
    exact: true,
    element: lazy(() => import("./pages/capital-goods/CapitalGoods")),
  },

  {
    path: "/",
    exact: true,
    element: lazy(() => import("./pages/home/HomeDashboard")),
  },
  {
    path: "/get-started",
    exact: true,
    element: lazy(() => import("./pages/home/GetStarted")),
  },

  //ESG module
  {
    path: "/emission-activities/esg",
    exact: true,
    element: lazy(() => import("./pages/esg/Esgacticity")),
  },

  {
    path: "/esg/projects/detail/:projectId",
    exact: true,
    element: lazy(() => import("./pages/esgmodule/project/Details")),
  },
  {
    path: "/esg/projects/:projectId/request",
    exact: true,
    element: lazy(() => import("./pages/esgmodule/Request")),
  },
  {
    path: "/esg/metric",
    exact: true,
    element: lazy(() => import("./pages/esgmodule/Metric")),
  },
  {
    path: "/emission-activities/esg/create",
    exact: true,
    element: lazy(() => import("./pages/esg/create-activity/CreateActivity")),
  },
  {
    path: "emission-activities/:reportId/esg-module",
    exact: true,
    element: lazy(() => import("./pages/esg/Environmental")),
  },
  {
    path: "/emission-activities/:reportId/esg-module/:section/:sectionId",
    exact: true,
    element: lazy(() => import("./pages/esg/Environmental")),
  },

  // ESG
  {
    path: "/esg",
    exact: true,
    // element: lazy(() => import("./pages/esgmodule/Home")),
    element: lazy(() => import("./pages/esgmodule/ESGJourney")),
  },
  {
    path: "/esg/dashboard",
    exact: true,
    element: lazy(() => import("./pages/esgmodule/Dashboard")),
  },
  {
    path: "/esg/new/dashboard",
    exact: true,
    element: lazy(() => import("./pages/esgmodule/Dashboard")),
  },
  {
    path: "/esg/document-hub",
    exact: true,
    element: lazy(() => import("./pages/esgmodule/Document")),
  },
  {
    path: "/esg/document-hub/:nodeID",
    exact: true,
    element: lazy(() => import("./pages/esgmodule/Documentnode")),
  },

  {
    path: "/esg/manage",
    exact: true,
    element: lazy(() => import("./pages/esgmodule/Manage")),
  },

  {
    path: "/esg/addmetric",
    exact: true,
    element: lazy(() => import("./pages/esgmodule/Addmetric")),
  },
  {
    path: "/esg/metric",
    exact: true,
    element: lazy(() => import("./pages/esgmodule/Metric")),
  },
  {
    path: "/esg/projects",
    exact: true,
    element: lazy(() => import("./pages/esgmodule/project/EsgProjesct")),
  },

  // CBAM
  {
    path: "/reports/cbam",
    exact: true,
    element: lazy(() => import("./pages/reports/cbam/ViewCbamProducts")),
  },
  {
    path: "/reports/cbam/products/:productId",
    exact: true,
    element: lazy(() => import("./pages/reports/cbam/ManageProducts")),
  },
  {
    path: "/reports/cbam/products/:productId/direct",
    exact: true,
    element: lazy(() => import("./pages/reports/cbam/emission/Direct")),
  },
  {
    path: "/reports/cbam/products/:productId/indirect",
    exact: true,
    element: lazy(() => import("./pages/reports/cbam/emission/Indirect")),
  },
  {
    path: "/reports/cbam/products/:productId/precursor",
    exact: true,
    element: lazy(() => import("./pages/reports/cbam/emission/Precursor")),
  },
  {
    path: "/external/cbam/submitter/:cbamToken/form",
    exact: true,
    element: lazy(() => import("./pages/forms/CbamSubmitter")),
  },
  //PCF
  {
    path: "/reports/pcf",
    exact: true,
    element: lazy(() => import("./pages/reports/pcf/ViewPcfProducts")),
  },
  {
    path: "/reports/pcf/products/:productId",
    exact: true,
    element: lazy(() => import("./pages/reports/pcf/ManagePcfProducts")),
  },
  {
    path: "/reports/pcf/products/:productId/:stageName",
    exact: true,
    element: lazy(() => import("./pages/reports/pcf/StagewiseEmissions")),
  },

  {
    path: "/master/products",
    exact: true,
    element: lazy(() => import("./pages/reports/cbam/Products/ProductList")),
  },

  // analytics
  {
    path: "/analytics",
    exact: true,
    element: lazy(() => import("./pages/analytics/Analytics")),
  },
  {
    path: "/analytics/:nodeId",
    exact: true,
    element: lazy(() => import("./pages/analytics/SingleNodeAnalyticView")),
  },
  {
    path: "/analytics/:nodeId/:scope/:categoryId",
    exact: true,
    element: lazy(() => import("./pages/analytics/CategoryAnalytics")),
  },
  {
    path: "/analytics/:nodeId/suppliers",
    exact: true,
    element: lazy(() => import("./pages/analytics/SuppliersAnalytics")),
  },
  {
    path: "/analytics/:nodeId/spend-group",
    exact: true,
    element: lazy(() => import("./pages/analytics/SpendGroupAnalytics")),
  },
 
  // analytics ghg dashboard
  {
    path: "/dashboard",
    exact: true,
    element: lazy(() => import("./pages/dashboard/index")),
  },
  {
    path: "/testing",
    exact: true,
    element: lazy(() => import("./pages/testing")),
  },
  {
    path: "/targetemmision",
    exact: true,
    element: lazy(() => import("./pages/TargetEmission/index")),
  },
  {
    path: "/dashboard/Scopes",
    exact: true,
    element: lazy(() => import("./pages/dashboard/Scopes")),
  },
  {
    path: "/dashboard/scope-1",
    exact: true,
    element: lazy(() => import("./pages/dashboard/Scope1")),
  },

  {
    path: "/dashboard/scope-2",
    exact: true,
    element: lazy(() => import("./pages/dashboard/Scope2")),
  },
  {
    path: "/dashboard/scope-3 cat1",
    exact: true,
    element: lazy(() => import("./pages/dashboard/Scope3")),
  },
  {
    path: "/dashboard/scope-3 cat2",
    exact: true,
    element: lazy(() => import("./pages/dashboard/Scope3Cat2")),
  },
  {
    path: "/dashboard/scope3-cat5",
    exact: true,
    element: lazy(() => import("./pages/dashboard/Scope3Cat5")),
  },
  {
    path: "/dashboard/scope3-other",
    exact: true,
    element: lazy(() => import("./pages/dashboard/Scope3OtherCat")),
  },
  // {
  //   path: "/dashboard/simulator/initiatives",
  //   exact: true,
  //   element: lazy(() => import("./pages/dashboard/CarbonSimulator/ManageInitiatives")),
  // },

   {
    path: "/dashboard/initiatives",
    exact: true,
    element: lazy(() => import("./pages/dashboard/Initiatives/Initiatives.jsx"))
  },

  // emission targets
  {
    path: "/information/emission-targets",
    exact: true,
    element: lazy(() => import("./pages/emission-targets/EmissionTargets")),
  },
  {
    path: "/information/emission-targets/create/:type",
    exact: true,
    element: lazy(() => import("./pages/emission-targets/EmissionTargetsForm")),
  },
  {
    path: "/information/emission-targets/edit/:id/:type",
    exact: true,
    element: lazy(() => import("./pages/emission-targets/EmissionTargetsForm")),
  },
  {
    path: "/information/emission-targets/:id/items/:name",
    exact: true,
    element: lazy(() => import("./pages/emission-targets/TargetGroupItem")),
  },
  // {
  //   path: "/information/base-metrics",
  //   exact: true,
  //   element: lazy(() => import("./pages/emission-targets/BaseMetrics")),
  // },
  {
    path: "/information/base-metrics/create/:type",
    exact: true,
    element: lazy(() => import("./pages/emission-targets/EmissionTargetsForm")),
  },
  {
    path: "/information/base-metrics/edit/:id/:type",
    exact: true,
    element: lazy(() => import("./pages/emission-targets/EmissionTargetsForm")),
  },
  {
    path: "/information/base-metrics/:id/items/:name",
    exact: true,
    element: lazy(() => import("./pages/emission-targets/TargetGroupItem")),
  },

  //base metrics
  {
    path: "/information/base-metrics",
    exact: true,
    element: lazy(() => import("./pages/metrics")),
  },
  {
    path: "/information/base-metrics/create",
    exact: true,
    element: lazy(() => import("./pages/metrics/CreateForm")),
  },
  {
    path: "/information/base-metrics/edit/:id",
    exact: true,
    element: lazy(() => import("./pages/metrics/CreateForm")),
  },
  {
    path: "/information/base-metrics/:type",
    exact: true,
    element: lazy(() => import("./pages/metrics")),
  },
  {
    path: "/information/base-metrics/add-data/:nodeId",
    exact: true,
    element: lazy(() => import("./pages/metrics/NodeData")),
  },
  {
    path: "/information/base-metrics/add-data/:nodeId/:actionType",
    exact: true,
    element: lazy(() => import("./pages/metrics/NodeData")),
  },
  {
    path: "/information/base-metrics/add-data/:nodeId/edit/:id",
    exact: true,
    element: lazy(() => import("./pages/metrics/NodeData")),
  },
  // Uncertainty Analysis
  {
    path: "/information/uncertainty-analysis",
    exact: true,
    element: lazy(
      () => import("./pages/uncertainty-analysis/UncertaintyAnalysis"),
    ),
    element: lazy(
      () => import("./pages/uncertainty-analysis/UncertaintyAnalysis"),
    ),
  },
  // reports
  {
    path: "/reports/gri",
    exact: true,
    element: lazy(() => import("./pages/reports/gri/ActivityHierarchy")),
  },
  {
    path: "/reports/iso",
    exact: true,
    element: lazy(() => import("./pages/reports/gri/ActivityHierarchy")),
  },
  {
    path: "/reports",
    exact: true,
    element: lazy(() => import("./pages/reports/ReportLanding")),
  },
  {
    path: "/reports/type/:tab",
    exact: true,
    element: lazy(() => import("./pages/reports/Reports")),
  },
  {
    path: "/reports/type/:reportType/create",
    exact: true,
    element: lazy(() => import("./pages/reports/create-reports/CreateReport")),
  },
  {
    path: "/reports/type/:reportType/create-report-gri",
    exact: true,
    element: lazy(
      () => import("./pages/reports/create-report-gri/CreateReport"),
    ),
  },
  {
    path: "/reports/type/activity/create",
    exact: true,
    element: lazy(() => import("./pages/reports/activity/CreateForm")),
  },

  //tcfd reports

  {
    path: "/reports/type/tcfd/:reportId",
    exact: true,
    element: lazy(() => import("./pages/reports/tcfd/StartPage")),
  },
  {
    path: "/reports/type/tcfd/:reportId/edit",
    exact: true,
    element: lazy(() => import("./pages/reports/tcfd/index")),
  },
  {
    path: "/ghg/report",
    exact: true,
    element: lazy(
      () => import("./pages/reports/ghg-inventory-report_v2/LandingPage.jsx"),
    ),
  },
  {
    path: "/ghg/report/history",
    exact: true,
    element: lazy(
      () => import("./pages/reports/ghg-inventory-report_v2/HistoryPage.jsx"),
    ),
  },

  //gri reports

  {
    path: "/reports/type/gri/:projectId",
    exact: true,
    element: lazy(() => import("./pages/reports/gri")),
  },
  {
    path: "/reports/type/gri/:projectId/:edit/:section/:sectionId",
    exact: true,
    element: lazy(() => import("./pages/reports/gri/GriFormPage")),
  },
  {
    path: "/reports/type/gri/:projectId/:edit",
    exact: true,
    element: lazy(() => import("./pages/reports/gri")),
  },

  // ppn reports
  {
    path: "/reports/type/ppn/:reportId",
    exact: true,
    element: lazy(() => import("./pages/reports/ppn0621/PPN")),
  },
  {
    path: "/reports/type/ppn/:reportId/edit",
    exact: true,
    element: lazy(() => import("./pages/reports/ppn0621/PPNSteps")),
  },
  {
    path: "/reports/ppn/policy",
    exact: true,
    element: lazy(() => import("./pages/reports/ppn0621/ProcurementPolicy")),
  },
  // brsr reports
  {
    path: "/reports/type/brsr/:reportId",
    exact: true,
    element: lazy(() => import("./pages/reports/brsr")),
  },
  {
    path: "/reports/type/brsr/:reportId/:edit",
    exact: true,
    element: lazy(() => import("./pages/reports/brsr")),
  },
  {
    path: "/reports/type/brsr/:reportId/:edit/:section/:sectionId",
    exact: true,
    element: lazy(() => import("./pages/reports/brsr")),
  },
  {
    path: "/reports/type/brsr/:reportId/:edit/:section/:sectionId/:subSectionId",
    exact: true,
    element: lazy(() => import("./pages/reports/brsr")),
  },

  //GHG reports

  {
    path: "/reports/type/GHG/create",
    exact: true,
    element: lazy(() => import("./pages/reports/GHGInventory/CreateReport")),
  },
  {
    path: "/reports/GHG",
    exact: true,
    element: lazy(
      () => import("./pages/reports/ghg-inventory-report_v2/LandingPage.jsx"),
    ),
  },
  {
    path: "/reports/type/GHG/:reportId",
    exact: true,
    element: lazy(() => import("./pages/reports/GHGInventory/GHG")),
  },
  {
    path: "/reports/type/GHG/:reportId/edit",
    exact: true,
    element: lazy(() => import("./pages/reports/GHGInventory/GHGSteps")),
  },
  // {
  //   path: "/reports/GHG/policy",
  //   exact: true,
  //   // element: lazy(() => import("./pages/reports/GHGInventory/ProcurementPolicy")),
  // },

  {
    path: "/upload/:type",
    exact: true,
    element: lazy(() => import("./pages/UploadData")),
  },
  {
    path: "/reports/type/brsr/:reportId/:edit/:section/:sectionId/:subSectionId",
    exact: true,
    element: lazy(() => import("./pages/reports/brsr")),
  },
  {
    path: "/emission-activities/:inputGroupId/supplier",
    exact: true,
    element: lazy(() => import("./pages/activities/SupplierActivity")),
  },
  {
    path: "/emission-activities/:inputGroupId/supplier/:supplierId",
    exact: true,
    element: lazy(() => import("./pages/activities/SupplierCategoryList")),
  },
  {
    path: "/emission-activities/:inputGroupId/supplier/:supplierId/category/:categoryId",
    exact: true,
    element: lazy(() => import("./pages/activities/SupplierCategoryDrawer")),
  },
  {
    path: "/information/supplier-collaboration",
    exact: true,
    element: lazy(() => import("./pages/suppliers-collab")),
  },
  {
    path: "/information/supplier-collaboration/:supplier/edit",
    exact: true,
    element: lazy(() => import("./pages/suppliers-collab/SupplierDetails")),
  },
  {
    path: "/information/supplier-collaboration/invite",
    exact: true,
    element: lazy(() => import("./pages/suppliers-collab/InviteForm")),
  },
  {
    path: "/emission-activities/uploads",
    exact: true,
    element: newUITenant ? NewUploadUI : OldUploadUI,
  },
  {
    path: "/archived/files",
    exact: true,
    element: lazy(() => import("./pages/custumdatastream/ManageUploads")),
  },
  //Asurrance Report
  {
    path: "/assurance-module",
    exact: true,
    element: lazy(() => import("./pages/AssuranceModule/index")),
  },
  {
    path: "/assurance-report",
    exact: true,
    element: lazy(() => import("./pages/AssuranceModule/report")),
  },
  {
    path: "/assurance",
    exact: true,
    element: lazy(() => import("./pages/AssuranceModule/Assurancemodule")),
  },
  {
    path: "/assurance-results",
    exact: true,
    element: lazy(() => import("./pages/AssuranceModule/Dataset")),
  },
  {
    path: "/assurance-report-logs",
    exact: true,
    element: lazy(() => import("./pages/AssuranceModule/AssuranceReport")),
  },
  /* -------------  Periodic Ingestion ------------- */
  {
    path: "/schedule-calculation/employee-commuting",
    exact: true,
    element: lazy(
      () => import("./pages/schedule-calculation/EmployeeCommuting"),
    ),
  },
  {
    path: "/schedule-calculation/electricity",
    exact: true,
    element: lazy(() => import("./pages/schedule-calculation/Electricity")),
  },
  {
    path: "/schedule-calculation/employee-commuting/organization/:id",
    exact: true,
    element: lazy(() => import("./pages/schedule-calculation/GHGCalculator")),
  },
  {
    path: "/schedule-calculation/electricity/organization/:id",
    exact: true,
    element: lazy(
      () => import("./pages/schedule-calculation/GHGCalculator_electrcity"),
    ),
  },
  /* ------------- carbon report ------------- */
  {
    path: "/reports/embodied-carbon-report",
    exact: true,
    element: lazy(() => import("./pages/reports/embodied-carbon/CreateForm")),
  },
  /* ------------- dashboard simulator ------------- */
  {
    path: "/dashboard/simulator/initiatives",
    exact: true,
    element: lazy(
      () => import("./pages/dashboard/CarbonSimulator/ManageInitiative"),
    ),
  },
  /* ------------- Emission Insights ------------- */
  {
    path: "/emission-insights",
    exact: true,
    element: lazy(() => import("./pages/dashboard/Userdefined/Usergenerate")),
  },
  // CCTS
  {
    path: "/ccts/dashboard",
    exact: true,
    element: lazy(() => import("./pages/ccts/Dashboard")),
  },
  {
    path: "/ccts/create",
    exact: true,
    element: lazy(() => import("./pages/ccts/ManageFocusMaterials")),
  },
  {
    path: "/ccts/batch/:id",
    exact: true,
    element: lazy(() => import("./pages/ccts/BatchCreation")),
  },
  {
    path: "/ccts/org-details",
    exact: true,
    element: lazy(() => import("./pages/ccts/OrganisationDetails")),
  },
  {
    path: "ccts/upload-data",
    exact: true,
    element: lazy(() => import("./pages/ccts/UploadData")),
  },
  /* -------------  Maker Checker  ------------- */

  {
    path: "/maker-checker/pocMatrix",
    exact: true,
    element: lazy(() => import("./pages/maker-checker/PocMatrix")),
  },
  {
    path: "/maker-checker/raiseRequests",
    exact: true,
    element: lazy(() => import("./pages/maker-checker/ManageRequests.jsx")),
  },
  {
    path: "/maker-checker/configureCategories",
    exact: true,
    element: lazy(() => import("./pages/maker-checker/ManageRequests.jsx")),
  },
  {
    path: "maker-checker/configureActivities",
    exact: true,
    element: lazy(
      () => import("./pages/maker-checker/ConfigureCategoryActivities.jsx"),
    ),
  },
  // {
  //   path: "/maker-checker/submitter",
  //   exact: true,
  //   element: lazy(() => import("./pages/maker-checker/DirectDataEntry.jsx")),
  // },
  {
    path: "/maker-checker/submitter",
    exact: true,
    element: lazy(() => import("./pages/maker-checker/submitter/index.jsx")),
  },
  {
    path: "/maker-checker/requests",
    exact: true,
    element: lazy(() => import("./pages/maker-checker/ClientAdmin.jsx")),
  },
  // {
  //   path: "/maker-checker/approvers",
  //   exact: true,
  //   element: lazy(() => import("./pages/maker-checker/Approvers.jsx")),
  // },
  {
    path: "/maker-checker/approvers",
    exact: true,
    element: lazy(() => import("./pages/maker-checker/approver/index.jsx")),
  },
  {
    path: "/maker-checker/approver/review/:id",
    exact: true,
    element: lazy(
      () => import("./pages/maker-checker/approver/ReviewPage.jsx"),
    ),
  },
  {
    path: "/maker-checker/submitter/review/:id",
    exact: true,
    element: lazy(
      () => import("./pages/maker-checker/approver/ReviewPage.jsx"),
    ),
  },
  {
    path: "/maker-checker/submitter/manual-review/:id",
    exact: true,
    element: lazy(
      () =>
        import("./pages/maker-checker/submitter/SubmitterManualReviewPage.jsx"),
    ),
  },
  {
    path: "/maker-checker/submitter/smart-extract-review/:batchId",
    exact: true,
    element: lazy(
      () =>
        import("./pages/maker-checker/submitter/SmartExtractReviewPage.jsx"),
    ),
  },
  {
    path: "/maker-checker/submitter/smart-extract-review/:batchId",
    exact: true,
    element: lazy(() => import("./pages/maker-checker/submitter/SmartExtractReviewPage.jsx")),
  },
  {
    path: "/maker-checker/approver/manual-review/:id",
    exact: true,
    element: lazy(
      () =>
        import("./pages/maker-checker/submitter/SubmitterManualReviewPage.jsx"),
    ),
  },
  /////
  {
    path: "/configureRoles",
    exact: true,
    element: lazy(
      () =>
        import("./pages/custumdatastream/submitterBasedUploads/RoleConfiguration.jsx"),
    ),
  },
  /* ------------- Category Configuration ------------- */
  {
    path: "/category-configuration/tenant-configuration",
    exact: true,
    element: lazy(() => import("./pages/category-configuration/pages/TenantConfiguration.jsx")),
  },
  {
    path: "/category-configuration/org-hierarchy",
    exact: true,
    element: lazy(() => import("./pages/category-configuration/pages/OrgHierarchy.jsx")),
  },

  //PCF
  {
    path: "/pcf-management",
    exact: true,
    element: lazy(
      () => import("./pages/PCFManagement/PcfLandingPage/PcfLanding.jsx"),
    ),
  },
  {
    path: "/pcf/new",
    exact: true,
    element: lazy(
      () => import("./pages/PCFManagement/PCFBuilder/PcfBuilder.jsx"),
    ),
  },
];

export const supplierPublicRoute = [
  {
    path: "/supplier/login",
    exact: true,
    element: lazy(() => import("./pages/suppliers-pages/SupplierLogin")),
  },
];

export const supplierRoutes = [
  {
    path: "*",

    element: lazy(() => import("./pages/suppliers-pages/PageNotFound")),
  },
  {
    path: "/un-authorized",

    element: lazy(() => import("./pages/UnAuthorized")),
  },
  {
    path: "/supplier",
    exact: true,
    element: lazy(() => import("./pages/suppliers-pages")),
  },

  {
    path: "/supplier/emission-activities/:inputGroupId",
    exact: true,
    element: lazy(() => import("./pages/suppliers-pages/AddData")),
  },
  {
    path: "/supplier/emission-activities/:inputGroupId/category/:categoryId",
    exact: true,
    element: lazy(
      () => import("./pages/suppliers-pages/SupplierCategoryDrawer"),
    ),
  },
  //////
];
